<template>
  <div>

    <form @submit.prevent="onSubmit">

      <div class="p-6 text-blue-800 bg-blue-100 border-2 border-blue-200 rounded-lg">
        <span class="font-bold">Merk!</span> Veileder for masterstudenter må være cand.pharm/master. Veileder for bachelorstudenter kan være reseptar/bachelor.
      </div>

      <div class="mt-12 flex items-center">
        <label class="font-bold" for="name">Hvor mange studenter kan dere ta i mot?</label>
        <select v-model="slotCount" class="ml-4">
          <option v-for="n in 4" :key="n" :value="n">
            {{ n }}
          </option>
        </select>
      </div>

      <table class="w-full mt-8">
        <thead>
          <tr>
            <th class="uppercase text-sm text-gray-500 py-2 text-left">Student</th>
            <th class="uppercase text-sm text-gray-500 py-2 pl-8 pr-2 text-center">Bachelor</th>
            <th class="uppercase text-sm text-gray-500 py-2 pr-8 pl-2 text-center">Master</th>
            <!-- <th class="uppercase text-sm text-gray-500 py-2 text-left" :class="{ 'invisible': !universitySelectVisible }">Studiested</th> -->
          </tr>
        </thead>
        <tbody>
          <tr v-for="(practiceSlot, ix1) in practiceSlots" :key="ix1">
            <td class="font-bold">Student {{ ix1 + 1 }}</td>
            <td class="pl-8 pr-2 text-center">
              <button class="p-2 focus:outline-none" @click.prevent="onStudyClick(practiceSlot, 0)" @keydown.space.prevent="onStudyClick(practiceSlot, 0)">
                <font-awesome-icon :icon="['far', practiceSlot.study == null || practiceSlot.study === 0 ? 'check-square' : 'square']" class="text-xl" />
              </button>
            </td>
            <td class="pr-8 pl-2 text-center">
              <button class="p-2 focus:outline-none" @click.prevent="onStudyClick(practiceSlot, 1)" @keydown.space.prevent="onStudyClick(practiceSlot, 1)">
                <font-awesome-icon :icon="['far', practiceSlot.study == null || practiceSlot.study === 1 ? 'check-square' : 'square']" class="text-xl" />
              </button>
            </td>
            <!-- <td class="py-1" :class="{ 'invisible': !universitySelectVisible }">
              <select v-model="practiceSlot.universityId">
                <option :value="null">Ikke viktig</option>
                <option v-for="(university, ix2) in universities" :key="ix2" :value="university.universityId">
                  {{ university.name }}
                </option>
              </select>
            </td> -->
          </tr>
        </tbody>
      </table>

<!-- 
      <div class="mt-6">
        <checkbox v-model="universitySelectVisible">Jeg ønsker å spesifisere studiested</checkbox>
      </div> -->


      <div class="flex justify-between mt-16">
        <button class="btn" @click.prevent="onPrevClick">
          <font-awesome-icon :icon="['far', 'chevron-left']" />
          <span class="inline-block ml-4">Forrige</span>
        </button>
        <button class="btn btn-primary" type="submit">
          <span class="inline-block mr-4">Neste</span> <font-awesome-icon :icon="['far', 'chevron-right']" />
        </button>
      </div>

    </form>
  </div>

</template>

<script>
import api from '@/api'
// import _ from 'lodash'
export default {
  name: 'ap-register-slots',
  data () {
    return {
      slotCount: 0,
      pharmacy: null,
      electionPeriod: null,
      practiceSlots: [],
      // universitySelectVisible: false
    }
  },
  computed: {
    universities () {
      return this.electionPeriod ? this.electionPeriod.universities : []
    }
  },
  methods: {
    onPrevClick () {
      this.$emit('prev')
    },
    async onSubmit () {
      await api.ap.createPracticeSlots(this.practiceSlots)
      this.$emit('submit')
    },
    onStudyClick (practiceSlot, study) {
      if (practiceSlot.study === 0 && study === 1) { practiceSlot.study = null }
      else if (practiceSlot.study === 1 && study === 0)  { practiceSlot.study = null }
      else if (practiceSlot.study === null && study === 0) { practiceSlot.study = 1 }
      else if (practiceSlot.study === null && study === 1) { practiceSlot.study = 0 }
    }
  },
  async mounted () {
    this.electionPeriod = await api.ap.getElectionPeriod()
    this.practiceSlots = await api.ap.getPracticeSlots()
    this.slotCount = this.practiceSlots.length > 0 ? this.practiceSlots.length : 1
    // this.universitySelectVisible = _.find(this.practiceSlots, ps => ps.universityId !== null)
  },
  watch: {
    'slotCount': {
      handler: function (val, old) {
        if (val < old) {
          this.practiceSlots.length = val
        } else {
          const addCount = val - this.practiceSlots.length
          for (let i = 0; i < addCount; i++) {
            this.practiceSlots.push({
              study: 0,
              universityId: null
            })
          }
        }
      }
    }
    // 'universitySelectVisible': function (val) {
    //   if (!val) {
    //     for (let i = 0; i < this.practiceSlots.length; i++) {
    //       this.practiceSlots[i].universityId = null
    //     }
    //   }
    // }
  }
}
</script>
